var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "row no-gutters client-profile-referrer drag-subtitle justify-content-end",
    },
    [
      _c("div", { staticClass: "col" }, [
        _c(
          "div",
          { staticClass: "row no-gutters" },
          _vm._l(_vm.visibleCustomFields, function (field) {
            return _c("div", { key: field.id, staticClass: "col-12" }, [
              _c("div", { staticClass: "d-flex flex-row align-items-center" }, [
                _vm.getVisibility(field.id) === "compact"
                  ? _c("i", {
                      directives: [
                        {
                          name: "b-tooltip",
                          rawName: "v-b-tooltip.left.viewport",
                          value: _vm.customFieldName(field.name),
                          expression: "customFieldName(field.name)",
                          modifiers: { left: true, viewport: true },
                        },
                      ],
                      staticClass: "fa text-light-gray mr-1 d-none d-lg-block",
                      class: _vm.getIconStyles(field),
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.getVisibility(field.id) === "full"
                  ? _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.left.viewport",
                            value: _vm.customFieldName(field.name),
                            expression: "customFieldName(field.name)",
                            modifiers: { left: true, viewport: true },
                          },
                        ],
                        staticClass: "referrer-name bold mr-1",
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm._f("truncateText")(
                                _vm.customFieldName(field.name),
                                _vm.MAX_NAME_LENGTH
                              )
                            ) +
                            "\n          "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip",
                        value: _vm.getValueTooltipOptions(field),
                        expression: "getValueTooltipOptions(field)",
                      },
                    ],
                    staticClass: "referrer-name",
                  },
                  [
                    field.type === "date"
                      ? [
                          _c(
                            "span",
                            { class: _vm._f("dateContextColor")(field.value) },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm._f("formatDateLocalCustom")(
                                      field.value,
                                      "MMM D, YYYY"
                                    )
                                  ) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ]
                      : field.type === "dropdown"
                      ? [
                          _c("span", [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm.getDropdownValue(field)) +
                                "\n              "
                            ),
                          ]),
                        ]
                      : [
                          _c("span", [
                            _vm._v(
                              "\n                " +
                                _vm._s(_vm._f("formatFieldValue")(field)) +
                                "\n              "
                            ),
                          ]),
                        ],
                  ],
                  2
                ),
              ]),
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-content-end" }, [
          _c("div", { staticClass: "col" }, [_vm._t("left-side")], 2),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "col-auto d-flex flex-row align-items-end justify-content-end",
            },
            [_vm._t("right-side")],
            2
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }